// extracted by mini-css-extract-plugin
export default {"modalContent":"Nav_modalContent__sJTWM","modalHeader":"Nav_modalHeader__rAfCG","modalFooter":"Nav_modalFooter__SrMVX","closeIcon":"Nav_closeIcon__DFpG4"};